// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2022project/q2/2022elderly/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getVoteList = (workType: number, page: number, search: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      workType,
      page,
      search,
    },
  });
};

const getDetail = (id: string) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

// 规则
export const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

export { getBaseInfo, getVoteList, getDetail, getNews };
